<template>
  <section>
    <div class="content-header">
      <h2>Magazine articles</h2>
    </div>
    <div class="content-wrapper">
      <ul>
        <li><a href="https://www.forbes.com/sites/forbescoachescouncil/2018/05/30/how-to-build-a-resilient-career-in-a-world-of-relentless-change/?sh=233a1d19358f" target="_blank">How to build a resilient career in a world of relentless change</a></li>
      </ul>
      <!-- <img src="@/assets/img/_content/career-review-3.png" width="400px" height="400px" class="img-fluid d-block mx-auto" alt="" > -->
    </div>
  </section>
</template>

<script>
// import Accordion from '../components/Accordion.vue'
// import SidebarMenu from '../components/SidebarMenu.vue'
// import {
//   Hooper,
//   Slide,
//   Navigation as HooperNavigation,
//   Pagination as HooperPagination
// } from 'hooper'
// import 'hooper/dist/hooper.css'

export default {
  name: '03',
  components: {
    // SidebarMenu,
    // Accordion,
    // Hooper,
    // Slide,
    // HooperNavigation,
    // HooperPagination
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },

  mounted () {
  }
}
</script>

<style>
</style>
